module.exports = __webpack_public_path__ + "images/graphic-header-2_347bf4e717fb54698733e3d7c8740cd0.png";